'use strict';

angular.module('licensure.helpers', [

])